/*
 * dga-pdp.js — interacties voor de WS2.0 productpagina (globaal geladen → editor-veilig).
 * - Galerij (thumbnails + pijltjes)
 * - Producttabs wisselen + download-kaarten klikbaar
 * - Specificaties-lijst → tabel, Voor-/Nadelen → twee kolommen
 * - "Bestel direct" knop → triggert de (verborgen) configurator-ATC
 */
(function () {
  /* ---------- Galerij ---------- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('.dga-thumb');
    var nav = e.target.closest('.dga-gal__nav');
    if (!thumb && !nav) return;
    var root = (thumb || nav).closest('.dga-pi');
    if (!root) return;
    var img = root.querySelector('.dga-gal__main img');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.dga-thumb'));
    if (!img || !thumbs.length) return;
    var current = thumbs.findIndex(function (t) { return t.classList.contains('is-active'); });
    if (current < 0) current = 0;
    var idx = current;
    if (thumb) idx = parseInt(thumb.getAttribute('data-index'), 10) || 0;
    if (nav) idx = current + (parseInt(nav.getAttribute('data-dir'), 10) || 1);
    if (idx < 0) idx = thumbs.length - 1;
    if (idx >= thumbs.length) idx = 0;
    var t = thumbs[idx];
    thumbs.forEach(function (b) { b.classList.remove('is-active'); });
    t.classList.add('is-active');
    // Video in de galerij (data-video = embed-URL, data-video-mp4 = eigen video; zie snippet dga-gal-video):
    // speler in het hoofdvak i.p.v. het voorbeeldplaatje. Bij een volgende afbeelding gaat de speler weer weg.
    var main = img.parentNode;
    var oldVid = main.querySelector('.dga-gal__video');
    if (oldVid) oldVid.remove();
    var vEmbed = t.getAttribute('data-video'), vMp4 = t.getAttribute('data-video-mp4');
    if (vEmbed || vMp4) {
      var el = document.createElement(vEmbed ? 'iframe' : 'video');
      if (vEmbed) {
        el.src = vEmbed; el.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen'; el.allowFullscreen = true;
        el.title = t.getAttribute('data-alt') || 'Video';
      } else {
        el.src = vMp4; el.controls = true; el.autoplay = true; el.playsInline = true;
      }
      el.className = 'dga-gal__video';
      el.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;border:0;background:#000';
      main.insertBefore(el, main.firstChild); // pijltjes en badges blijven erboven
      return;
    }
    img.style.opacity = '0';
    setTimeout(function () {
      img.src = t.getAttribute('data-src');
      img.alt = t.getAttribute('data-alt') || '';
      img.style.opacity = '1';
    }, 150);
  });

  /* Speel-icoon op video-thumbnails in de galerij */
  (function () {
    var st = document.createElement('style');
    st.textContent = '.dga-thumb[data-video],.dga-thumb[data-video-mp4]{position:relative}' +
      '.dga-thumb[data-video]::after,.dga-thumb[data-video-mp4]::after{content:"";position:absolute;inset:0;margin:auto;width:30px;height:30px;border-radius:50%;' +
      'background:rgba(0,0,0,.65) url("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27%3E%3Cpath fill=%27%23fff%27 d=%27M8 5v14l11-7z%27/%3E%3C/svg%3E") center/16px no-repeat;pointer-events:none}';
    document.head.appendChild(st);
  })();

  /* ---------- Offerte-knoppen → Quotify-flow met gekozen opties ----------
     Triggert de bestaande (verborgen) #request-a-quote knop van de configurator:
     die voegt de geconfigureerde opties toe aan de cart en opent het Quotify-offerteformulier.
     Geen #request-a-quote aanwezig (Quotify uit) → de link valt terug op de href. */
  var dgaPendingQuote = false;

  // Opent de Quotify-popup direct (knop in de cart-drawer) en slaat de drawer-stap over
  function dgaOpenQuotify() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return false;
    var qbtn = drawer.querySelector('[data-quotify-convert-cart]');
    if (!qbtn) return false;
    qbtn.click(); // → Quotify-popup
    if (typeof drawer.close === 'function') drawer.close();
    else { drawer.classList.remove('active', 'animate'); document.body.classList.remove('overflow-hidden'); }
    return true;
  }

  // Zodra de cart-drawer opent (= cart bijgewerkt na toevoegen), meteen door naar Quotify en de drawer sluiten
  (function () {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof MutationObserver === 'undefined') return;
    new MutationObserver(function () {
      if (dgaPendingQuote && drawer.classList.contains('active')) {
        dgaPendingQuote = false;
        dgaOpenQuotify();
      }
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  })();

  document.addEventListener('click', function (e) {
    var q = e.target.closest('.dga-quote-trigger');
    if (!q) return;
    // Capture-fase + stoppen: zo kan ook de Shopify-editor de link-click niet kapen
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    if (dgaQLoader && !dgaQLoader.hidden) return; // al bezig: geen tweede keer in de cart
    dgaQuoteLoading(true);

    var atc = document.querySelector('.nf-atc-addons') || document.querySelector('product-form.product-form .product-form__submit');
    if (atc) {
      // Configuratie toevoegen aan de cart; de observer opent daarna direct Quotify (drawer-stap overgeslagen)
      dgaPendingQuote = true;
      atc.click();
      // veiligheidsnet als de drawer al openstond / observer niet vuurt
      setTimeout(function () { if (dgaPendingQuote) { dgaPendingQuote = false; dgaOpenQuotify(); } }, 3000);
      return;
    }
    // Geen configurator-ATC: probeer de bestaande quote-knop, anders direct Quotify
    var rq = document.getElementById('request-a-quote');
    if (rq) { rq.click(); return; }
    dgaOpenQuotify();
  }, true);

  /* ---------- Laadteken tot het Quotify-formulier in beeld is ----------
     Klik → cart → Quotify-API → iframe duurt 2 tot 7 s (gemeten 20-10-2026). Het laadteken ligt net ONDER
     de Quotify-iframe (z-index 9999): verschijnt het formulier, dan schuift het er vanzelf overheen.
     Weg bij de load van #quotify-frame, bij sluiten, of na 15 s als vangnet. */
  var dgaQLoader = null, dgaQTimer;
  function dgaQuoteLoading(on) {
    if (on && !dgaQLoader) {
      var de = (document.documentElement.lang || '').indexOf('de') === 0;
      var st = document.createElement('style');
      st.textContent = '.dga-qload{position:fixed;inset:0;z-index:9998;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,.35)}.dga-qload[hidden]{display:none}' +
        '.dga-qload__box{display:flex;align-items:center;gap:14px;background:#fff;color:#000;border-radius:50px;padding:14px 26px 14px 18px;font:700 16px/1.2 Fustat,"Helvetica Neue",Arial,sans-serif;box-shadow:0 12px 40px rgba(0,0,0,.2)}' +
        '.dga-qload__spin{width:26px;height:26px;border-radius:50%;border:3px solid #EEECEA;border-top-color:#0060D8;animation:dga-qspin .8s linear infinite}' +
        '@keyframes dga-qspin{to{transform:rotate(360deg)}}@media (prefers-reduced-motion:reduce){.dga-qload__spin{animation-duration:2s}}';
      document.head.appendChild(st);
      dgaQLoader = document.createElement('div');
      dgaQLoader.className = 'dga-qload';
      dgaQLoader.innerHTML = '<div class="dga-qload__box" role="status"><span class="dga-qload__spin" aria-hidden="true"></span>' +
        (de ? 'Angebotsformular wird geladen …' : 'Offerteformulier wordt geladen …') + '</div>';
      document.body.appendChild(dgaQLoader);
    }
    if (!dgaQLoader) return;
    dgaQLoader.hidden = !on;
    clearTimeout(dgaQTimer);
    if (on) dgaQTimer = setTimeout(function () { dgaQuoteLoading(false); }, 15000);
  }
  // Ook de offerteknop in de cart-drawer (geen .dga-quote-trigger)
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-quotify-convert-cart]')) dgaQuoteLoading(true);
  }, true);
  // load bubbelt niet, maar is wel in de capture-fase op document te vangen
  document.addEventListener('load', function (e) {
    if (e.target.id === 'quotify-frame' && e.target.getAttribute('src') !== 'about:blank') dgaQuoteLoading(false);
  }, true);
  window.addEventListener('message', function (e) {
    if (e.data === 'close-quote-frame') dgaQuoteLoading(false);
  });

  /* ---------- Configurator-accordeon op mobiel: altijd naar beneden uitklappen ----------
     Voorkomt de "springt omhoog"-indruk door scroll-anchoring: bij openen scrollen we de
     geopende sectie naar boven zodat de inhoud eronder zichtbaar wordt. */
  document.addEventListener('click', function (e) {
    var sum = e.target.closest('.dga-acc__summary');
    if (!sum || window.innerWidth >= 1024) return;
    var det = sum.closest('details');
    if (!det) return;
    setTimeout(function () {
      if (det.open) det.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 60);
  });

  /* ---------- Tabs + downloads + bestel direct ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.dga-tab-btn');
    if (btn) {
      var root = btn.closest('.dga-tabs');
      if (root) {
        var tab = btn.getAttribute('data-tab');
        root.querySelectorAll('.dga-tab-btn').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        root.querySelectorAll('.dga-tab-panel').forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-panel') === tab); });
      }
      return;
    }

    var card = e.target.closest('.dga-dl__rte');
    if (card && !e.target.closest('a')) {
      var link = card.querySelector('a[href]');
      if (link) window.open(link.getAttribute('href'), link.getAttribute('target') || '_blank', 'noopener');
      return;
    }

    var bestel = e.target.closest('.dga-bestel');
    if (bestel) {
      e.preventDefault();
      var sec = bestel.closest('.dga-pi');
      var atc = sec && sec.querySelector('.nf-atc-addons');
      if (atc) atc.click();
      return;
    }

    // Betrouwbaar sluiten van de "Meer informatie"-dialog (kruisje) — werkt ook in de editor,
    // onafhankelijk van het animationend-event in component-dialog.js
    var dlgClose = e.target.closest('.dialog-close');
    if (dlgClose) {
      e.preventDefault();
      var dlg = dlgClose.closest('dialog');
      if (dlg) {
        dlg.classList.remove('hide');
        try { dlg.close(); } catch (_) {}
      }
      document.body.classList.remove('overflow-hidden');
    }
  });

  /* ---------- Transformaties (specs → tabel, voor/nadelen → kolommen) ---------- */
  /* Energieklasse + verbruik staan in een eigen tabel naast de specs; hier
     schuiven we die rijen onderaan de specificatietabel. Lukt dat niet, dan
     blijft het losse blok staan (zichtbaar, alleen als tweede tabel). */
  function mergeEnergie(box) {
    var extra = box.parentNode && box.parentNode.querySelector('[data-dga-spec-extra]');
    if (!extra) return;
    var doel = box.querySelector('table tbody') || box.querySelector('table');
    var bron = extra.querySelector('table tbody');
    if (!doel || !bron) return;
    while (bron.firstElementChild) doel.appendChild(bron.firstElementChild);
    extra.remove();
  }

  function transform(root) {
    root.querySelectorAll('[data-dga-spec]').forEach(function (box) {
      if (box.dataset.done) return;
      var items = box.querySelectorAll('li');
      if (!items.length) { box.dataset.done = '1'; mergeEnergie(box); return; }
      var rows = '';
      Array.prototype.slice.call(items).forEach(function (li) {
        var txt = (li.textContent || '').trim().replace(/;\s*$/, '');
        var idx = txt.indexOf(':');
        if (idx > -1) rows += '<tr><td>' + txt.slice(0, idx).trim() + '</td><td>' + txt.slice(idx + 1).trim() + '</td></tr>';
        else rows += '<tr><td colspan="2">' + txt + '</td></tr>';
      });
      box.innerHTML = '<table>' + rows + '</table>';
      box.dataset.done = '1';
      mergeEnergie(box);
    });

    root.querySelectorAll('[data-dga-pc]').forEach(function (box) {
      if (box.dataset.done) return;
      var rte = box.querySelector('.rte') || box;
      var pos = [], neg = [], bucket = pos;
      // Diep zoeken (metafield_tag nest de inhoud in een wrapper)
      Array.prototype.slice.call(rte.querySelectorAll('p, ul, ol')).forEach(function (node) {
        var t = (node.textContent || '').trim().toLowerCase();
        if (node.tagName === 'P') {
          if (/(pros|voordel|vorteil)/.test(t)) bucket = pos;
          else if (/(cons|nadel|aandacht|nachteil|hinweis)/.test(t)) bucket = neg;
          return;
        }
        Array.prototype.slice.call(node.querySelectorAll('li')).forEach(function (li) { bucket.push(li.innerHTML); });
      });
      if (!pos.length && !neg.length) { box.dataset.done = '1'; return; }
      function col(title, cls, arr) {
        if (!arr.length) return '';
        return '<div class="dga-pc-col ' + cls + '"><h3>' + title + '</h3><ul>' + arr.map(function (x) { return '<li>' + x + '</li>'; }).join('') + '</ul></div>';
      }
      var de = (document.documentElement.lang || '').indexOf('de') === 0;
      box.innerHTML = '<div class="dga-pc-grid">' + col(de ? 'Vorteile' : 'Voordelen', 'pos', pos) + col(de ? 'Hinweise' : 'Aandachtspunten', 'neg', neg) + '</div>';
      box.dataset.done = '1';
    });
  }

  function initAll() { document.querySelectorAll('.dga-tabs').forEach(transform); }
  if (document.readyState !== 'loading') initAll(); else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (e) {
    var sec = (e.target && e.target.querySelector) ? e.target.querySelector('.dga-tabs') : null;
    if (sec) transform(sec); else initAll();
    // Reveal opnieuw aanzetten voor net (her)geladen secties in de editor
    if (e.target && e.target.querySelectorAll) revealObserve(e.target.querySelectorAll('[data-reveal]'));
  });

  /* ---------- Scroll-reveal: secties faden zacht omhoog in beeld ---------- */
  var revealIO = null;
  function revealObserve(nodes) {
    if (!nodes || !nodes.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(nodes, function (n) { n.classList.add('dga-reveal', 'in'); });
      return;
    }
    if (!revealIO) {
      revealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); revealIO.unobserve(en.target); } });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    }
    Array.prototype.forEach.call(nodes, function (n) {
      if (n.dataset.revealInit) return;
      n.dataset.revealInit = '1';
      n.classList.add('dga-reveal');
      revealIO.observe(n);
    });
  }
  function initReveal() { revealObserve(document.querySelectorAll('[data-reveal]')); }
  if (document.readyState !== 'loading') initReveal(); else document.addEventListener('DOMContentLoaded', initReveal);

  /* Reveal-basisstijl injecteren (zodat secties geen eigen CSS nodig hebben) */
  if (!document.getElementById('dga-reveal-style')) {
    var st = document.createElement('style');
    st.id = 'dga-reveal-style';
    st.textContent = '.dga-reveal{opacity:0;transform:translateY(18px);transition:opacity .6s ease,transform .6s ease}.dga-reveal.in{opacity:1;transform:none}@media (prefers-reduced-motion:reduce){.dga-reveal,.dga-reveal.in{opacity:1;transform:none;transition:none}}';
    document.head.appendChild(st);
  }

  /* ---------- Sticky CTA: zichtbaar tot de sectie "Na je aanvraag", daarna weg (erachter geschoven) ---------- */
  (function () {
    var bar = document.querySelector('[id^="dga-sticky-"]');
    if (!bar) return;
    // Uit de stacking-context van de hero halen → altijd bovenop, nooit doorschijnend achter andere secties
    if (bar.parentNode !== document.body) document.body.appendChild(bar);

    var na = document.querySelector('[id^="dga-na-"]') || document.querySelector('.dga-na');
    if (!na || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      // verberg zodra de top van "Na je aanvraag" de onderkant van het scherm bereikt; blijf verborgen daaronder
      var top = entries[0].boundingClientRect.top;
      bar.classList.toggle('is-hidden', top <= window.innerHeight);
    }, { threshold: 0 }).observe(na);
  })();
})();
